<script>
export default {
   inserted: function (el) {
        el.getElementsByClassName('img')[0].onclick = function() {
            el.classList.add('show-popup')
        }
        el.getElementsByClassName('popup')[0].onclick = function() {
            el.classList.remove('show-popup')
        }
   }
}
</script>